export const legacyCssVariables = {
  "--sjs-layer-1-background-500": "--sjs2-color-bg-basic-primary",
  "--sjs-layer-1-background-400": "--sjs2-color-bg-basic-primary-dim",
  "--sjs-layer-1-foreground-100": "--sjs2-color-fg-basic-primary",
  "--sjs-layer-1-foreground-50": "--sjs2-color-fg-basic-secondary",
  "--sjs-layer-3-background-500": "--sjs2-color-bg-basic-secondary",
  "--sjs-layer-3-background-400": "--sjs2-color-bg-basic-secondary-dim",
  //"--sjs-layer-3-foreground-50": "--sjs2-color-fg-basic-secondary",
  "--sjs-layer-2-background-500": "--sjs2-color-component-formbox-design-bg",
  "--sjs-special-haze": "--sjs2-color-utility-overlay",
  "--sjs-border-10": "--sjs2-color-border-basic-secondary",
  "--sjs-primary-background-500": "--sjs2-color-project-brand-600",
  "--sjs-primary-background-10": "--sjs2-color-bg-brand-secondary",
  "--sjs-primary-background-400": "--sjs2-color-bg-brand-primary-dim",
  "--sjs-primary-foreground-100": "--sjs2-color-fg-static-main-primary",
  "--sjs-semantic-red-background-500": "--sjs2-color-bg-alert-primary",
  "--sjs-semantic-red-background-10": "--sjs2-color-bg-alert-secondary",
  "--sjs-semantic-blue-background-500": "--sjs2-color-bg-note-primary",
  "--sjs-semantic-blue-background-10": "--sjs2-color-bg-note-secondary",
  "--sjs-semantic-yellow-background-500": "--sjs2-color-bg-warning-primary",
  "--sjs-semantic-yellow-background-10": "--sjs2-color-bg-warning-secondary",
  //"--sjs-semantic-yellow-foreground-100": "--sjs2-color-fg-static-main-primary",
  "--sjs-special-background": "--sjs2-color-utility-surface-designer",
  "--sjs-layer-1-foreground-75": "--sjs2-color-fg-basic-primary-muted",
  "--sjs-special-glow": "--sjs2-color-utility-shadow-floating-default",
  "--sjs-special-shadow": "--sjs2-color-utility-shadow-surface-default",
  //"--sjs-layer-2-foreground-100": "--sjs2-color-fg-basic-primary",
  //"--sjs-layer-2-foreground-75": "--sjs2-color-fg-basic-primary-muted",
  //"--sjs-layer-2-foreground-50": "--sjs2-color-fg-basic-secondary",
  "--sjs-border-25-overlay": "--sjs2-color-utility-scrollbar",

  "--ctr-font-unit": "--sjs2-base-unit-font-size",
  "--ctr-line-height-unit": "--sjs2-base-unit-line-height",
  "--ctr-size-unit": "--sjs2-base-unit-size",
  "--ctr-spacing-unit": "--sjs2-base-unit-spacing",
  "--ctr-corner-radius-unit": "--sjs2-base-unit-radius",
  "--ctr-stroke-unit": "--sjs2-base-unit-border-width"
};